import axios from 'axios';
import { ContentListingType } from '../constants';

export const uploadFile = async (contentListingId, file, contentListingType = ContentListingType.STATIC) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = `/api/content-listings/${contentListingId}/items/static/file`;
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = `/api/content-listings/${contentListingId}/items/interactive/file`;
  } else {
    throw new Error('Invalid type was provided');
  }

  const form = new FormData();
  form.append('file', file);
  const { data } = await axios.put(url, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const getItems = async (contentListingId, contentListingType = ContentListingType.STATIC, categorized = false) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = `/api/content-listings/${contentListingId}/items/static?categorized=${categorized}`;
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = `/api/content-listings/${contentListingId}/items/interactive?categorized=${categorized}`;
  } else {
    throw new Error('Invalid type was provided');
  }

  const { data } = await axios.get(url);
  return data;
};

export const deleteItem = async (listItemId, contentListingType = ContentListingType.STATIC) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = `/api/content-listings/items/static/${listItemId}`;
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = `/api/content-listings/items/interactive/${listItemId}`;
  } else {
    throw new Error('Invalid type was provided');
  }

  const { data } = await axios.delete(url);
  return data;
};

export const updateItem = async (listItemId, form, contentListingType = ContentListingType.STATIC) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = `/api/content-listings/items/static/${listItemId}`;
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = `/api/content-listings/items/interactive/${listItemId}`;
  } else {
    throw new Error('Invalid type was provided');
  }

  const { data } = await axios.patch(url, form);
  return data;
};

export const bulkUpdateItems = async (items, contentListingType = ContentListingType.STATIC) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = '/api/content-listings/items/static/bulk-update';
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = '/api/content-listings/items/interactive/bulk-update';
  } else {
    throw new Error('Invalid type was provided');
  }

  const { data } = await axios.patch(url, items);
  return data;
};

export const createItem = async (form, contentListingId, contentListingType = ContentListingType.STATIC) => {
  let url;
  if (contentListingType === ContentListingType.STATIC) {
    url = `/api/content-listings/${contentListingId}/items/static`;
  } else if (contentListingType === ContentListingType.INTERACTIVE) {
    url = `/api/content-listings/${contentListingId}/items/interactive`;
  } else {
    throw new Error('Invalid type was provided');
  }

  const { data } = await axios.post(url, form);
  return data;
};